import React from "react";
import SearchWorkspacePage from "./features/search/pages/SearchWorkspacePage";

export default function App() {
  return <SearchWorkspacePage />;
}
